{
  "note": "The 16 Commodore 64 colours (Colodore, Philip 'Pepto' Timmermann's measured palette). Index = the C64 colour number. Used for the per-level block colours (spec 05 §4) and the 1987 mode LUT.",
  "colours": [
    "#000000", "#FFFFFF", "#813338", "#75CEC8", "#8E3C97", "#56AC4D", "#2E2C9B", "#EDF171",
    "#8E5029", "#553800", "#C46C71", "#4A4A4A", "#7B7B7B", "#A9FF9F", "#706DEB", "#B2B2B2"
  ]
}
